class BaseScenesPermissions {
    constructor({ enabled = false, show = false } = {}) {
        this.enabled = enabled
        this.show = show
    }
}

export default BaseScenesPermissions
